import React from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
import type { Location } from 'react-router-dom'

const FormsPage = React.lazy(() => import('../pages/Forms/FormsPage'))
const FormResultsPage = React.lazy(() => import('../pages/Forms/FormResultsPage'))

/** Office Forms list + Results, gated by the `Forms` VisibleTabs flag (set only when dbo.Forms has rows). */
export const getFormsRoutes = (
    loggedIn: boolean,
    visibleTabs: string[] | undefined,
    location: Location,
    loginRedirect: string,
): RouteObject[] => {
    const guard = (page: React.ReactElement) =>
        loggedIn && visibleTabs?.includes('Forms') ? page : <Navigate to={loginRedirect} state={{ from: location }} replace />
    return [
        { path: '/forms', element: guard(<FormsPage />) },
        { path: '/forms/:formId', element: guard(<FormResultsPage />) },
    ]
}
